import React, { FC, useCallback } from 'react'
import text from 'styles/utility/text.module.scss'
import format from 'date-fns/format'
import { FirebaseTimestampType } from 'firebase/index'
import { Card, CardInner } from 'components/Card'
import classNames from 'classnames'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { BlueButton } from 'components/Button'
import { CAMPAIGN_STATUS } from 'constants/campaign'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { CampaignStatus } from 'types/campaign'
import { parseCampaignStatus } from 'lib/helper'

type Props = {
  campaignId: string
  name: string
  periodStart: FirebaseTimestampType
  periodEnd: FirebaseTimestampType
  status: CampaignStatus
}

const CampaignCard: FC<Props> = (props) => {
  const { campaignId, name, periodStart, periodEnd, status } = props
  const dispatch = useDispatch()
  const goToEditPage = useCallback(() => dispatch(push(`/admin/campaign_cms/${campaignId}`)), [campaignId])
  const period = `${format(periodStart.toDate(), 'yyyy年M月d日')}〜${format(periodEnd.toDate(), 'yyyy年M月d日')}`

  return (
    <Card>
      <CardInner>
        <h3 className={classNames(text.color_blue_main, text.font_bold, text.font_medium)}>{name}</h3>
        <p className={text.font_small}>掲載期間 : {period}</p>
        <p className={text.font_small}>ステータス : {parseCampaignStatus(periodStart, periodEnd, status)}</p>
        <Spacer size={10} />
        <FlexColumn alignItems={'center'}>
          <BlueButton label={'編集する'} onClick={goToEditPage} size={'xsmall'} type={'main'} />
        </FlexColumn>
      </CardInner>
    </Card>
  )
}

export default CampaignCard
